import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "31",
  height: "43",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0083CC",
      d: "M30.923 11.875v25.943A5.18 5.18 0 0 1 25.741 43H5.181A5.18 5.18 0 0 1 0 37.818V5.182A5.18 5.18 0 0 1 5.182 0h13.866z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#52C1FF",
      d: "M30.923 11.875H21.19a2.14 2.14 0 0 1-2.142-2.141V0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M7.853 28.521c.915 0 1.41-.37 1.41-1.57v-7.164h1.227v7.164c0 1.805-.907 2.78-2.637 2.78zM17.04 22.541c0 1.79-.948 2.78-2.62 2.78h-1.024v2.998h-1.227v-8.532h2.251c1.672 0 2.62 1.016 2.62 2.754m-1.26 0c0-1.05-.453-1.587-1.377-1.587h-1.007v3.191h1.007c.933 0 1.386-.503 1.378-1.604M18.023 25.783v-3.468c0-1.73.949-2.654 2.494-2.654 1.512 0 2.419.915 2.486 2.595h-1.218c-.05-.983-.487-1.411-1.268-1.411-.78 0-1.243.453-1.243 1.486v3.452c0 1.033.487 1.487 1.277 1.487.815 0 1.302-.454 1.302-1.428v-1.067H20.5v-1.1h2.562v2.167c-.025 1.671-.983 2.603-2.52 2.603s-2.52-.932-2.52-2.662"
    }, null, -1)
  ])))
}
export default { render: render }